export default __webpack_public_path__ + "static/media/uploader-abbottLite-2.3b00ae54.png";